import TaboolaCampaignModel from './TaboolaCampaignModel';
import ExportModel from '../../lib/ExportModel';

export default {
  async getConfig(account) {
    // Create Campaign Model
    const campaignModel = new TaboolaCampaignModel(account);
    return ExportModel(campaignModel);
  },
};
